<template>
  <ITMLayout>
    <div class="overflow-x" v-horizontal-scroll>
      <FixedPlaceholder :component="ITMHorizontalMenu" :tabs="tabs" horizontal />
      <div class="p-5">
        <slot />
      </div>
    </div>
  </ITMLayout>
</template>

<script>
import FixedPlaceholder from '../common/fixedPlaceholder/FixedPlaceholder.vue'
import ITMLayout from './ITMLayout.vue';
import ITMHorizontalMenu from './ITMHorizontalMenu.vue';
export default {
  components: { ITMLayout, FixedPlaceholder },
  data() {
    return {
      tabs: {
        'CUSTOMERS': { text: 'CUSTOMERS', url: { name: 'itmCustomers' } },
        'ORDERS': { text: 'ORDERS', url: { name: 'itmOrders' } },
        'PRODUCTS': { text: 'PRODUCTS', url: { name: 'itmProducts' } },
        'DASHBOARD': { text: 'REPORTS', url: { name: 'itmDashboard' } },
        'SEARCH': { text: 'SEARCH', url: { name: 'itmSearch' } },
       'NOTIFICATION':{text:'NOTIFICATION',url:{name:'itmNotification'}},
      },
      ITMHorizontalMenu
    };
  },
  
}
</script>